import React from 'react';

import './AppHeader.scss';

import i18n from 'i18n';
import { ActorMenu } from './ActorMenu';
import {
  AppHeaderProps,
  AppHeaderModel,
  AppHeaderState,
} from './AppHeaderModel';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import appHeaderLogo from 'assets/new_header_logo.svg';
import { Modal } from 'components/Modal/Modal';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { hasFuncs } from 'core/permission/PermissionDSL';
import { Permission } from 'core/auth/Permission';
import { LoadingIndicator } from 'components/LoadingIndicator';
import { AppHeaderNotificationBar } from './AppHeaderNotificationBar';

export class AppHeader extends React.Component<AppHeaderProps, AppHeaderState> {
  menuRef: any;
  handler: number;

  constructor(props: any) {
    super(props);
    this.menuRef = React.createRef();
    this.state = this.props.model.state;
    this.handler = this.props.model.event.add((model) => {
      this.setState(model.state);
    });
  }

  logout = () => {
    this.props.model.logout();
  };

  changeLanguage = () => {
    this.props.model.showHideAccoutMenu();
    this.props.model.showChangeLanguageAlertModel();
  };

  toggle = () => {
    this.props.model.toggle();
  };

  showHideAcountMenu = () => {
    this.props.model.showHideAccoutMenu();
    this.setState(this.props.model.state);
  };

  dismiss = (e: any) => {
    if (this.menuRef.current && this.menuRef.current.contains(e.target)) {
      return;
    }
    if (this.props.model.state.menuShown) {
      this.showHideAcountMenu();
    }
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.dismiss, false);
  }

  componentWillUnmount() {
    this.handler && this.props.model.event.remove(this.handler);
    document.removeEventListener('mousedown', this.dismiss);
  }

  accountMenu(model: AppHeaderModel) {
    const classes = model.state.menuShown
      ? 'account-menu'
      : 'account-menu hidden';
    return (
      <ul className={classes}>
        <PermissionChecker permissionAware={hasFuncs(Permission.ACCOUNT_SUDO)}>
          <li className='sudo' onClick={this.props.model.sudo}>
            {i18n.t<string>('appHeader.sudo.title')}
          </li>
        </PermissionChecker>
        <li
          className='changePassword'
          onClick={this.props.model.changePassword}
        >
          {i18n.t<string>('appHeader.changePassword')}
        </li>
        {/* <li className='changeLanguage' onClick={this.changeLanguage}>
          {i18n.t<string>(`locales.${model.language}`)}
        </li> */}
        <li className='logout' onClick={this.logout}>
          {i18n.t<string>('appHeader.logout')}
        </li>
      </ul>
    );
  }

  renderModal(modalData) {
    const model = this.props.model;
    const ModalContent: typeof React.Component = modalData.component;
    return (
      <Modal
        fullScreen={modalData.fullScreen}
        title={modalData.title}
        primaryButton={
          modalData.confirmBtnData && {
            title: modalData.confirmBtnData.title,
            callback: modalData.confirmBtnData.callback,
          }
        }
        secondaryButton={{
          title: i18n.t<string>('common.buttons.close'),
          callback: model.hideModal,
        }}
        dismiss={model.hideModal}
        animation={false}
        className={modalData.modalClassName}
      >
        {ModalContent ? (
          <ModalContent {...modalData.componentProps} />
        ) : (
          modalData.message
        )}
      </Modal>
    );
  }

  render() {
    const model = this.props.model;
    const actorMenu =
      model.actorMenuModel !== null ? (
        <ActorMenu model={model.actorMenuModel} />
      ) : (
        ''
      );
    const email = model.account !== null ? model.account.email : '';
    const env = process.env.REACT_APP_ENV ?? '';
    return (
      <div className={`app-header ${env}`}>
        <div className='h-[40px]'>
          <AppHeaderNotificationBar />
        </div>
        <div className='header-main'>
          {model.state.loading && <LoadingIndicator />}
          <a className='logo' href='/'>
            <img src={appHeaderLogo} srcSet={appHeaderLogo} alt='logo' />
          </a>
          {model.account !== null && (
            <div className='toggle' onClick={this.toggle}>
              <FontAwesomeIcon icon={faBars} />
            </div>
          )}
          {actorMenu}
          {this.state.modalData && this.renderModal(model.state.modalData)}
          {model.account !== null && (
            <div className='account-info' ref={this.menuRef}>
              <div className='menu-title' onClick={this.showHideAcountMenu}>
                <span>{email}</span>
                <span className='arrow' />
              </div>
              {this.accountMenu(model)}
            </div>
          )}
        </div>
      </div>
    );
  }
}
